<template>
  <LayoutContainer id="newsletter-confirmed" class="mt-12">
    <h1 class="mb-5 text-center text-lg font-bold uppercase tracking-wide">
      Newsletter Confirmed
    </h1>

    <p class="mx-auto max-w-xl text-center text-sm">
      Thank you for confirming your subscription to our newsletter! We're
      excited to have you on board. Keep an eye on your inbox for the latest
      updates, exclusive content, and special offers.
    </p>
  </LayoutContainer>
</template>
